(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    
  const items = document.querySelectorAll('.blog-articles .article');
  const btn = document.getElementById('read-more-btn');

  let visible = 6;

  items.forEach((el, i) => {
    if (i < visible) el.style.display = 'flex';
    else el.style.display = 'none';
  });

  if (items.length <= visible && btn) {
    btn.style.display = 'none';
  }

  btn?.addEventListener('click', () => {
    visible += 6;

    items.forEach((el, i) => {
      if (i < visible) el.style.display = 'flex';
    });

    if (visible >= items.length) {
      btn.style.display = 'none';
    }
  });

    const isComingSoon =
    window.location.search.includes('comingSoon') ||
    window.location.hash.includes('comingSoon');

    if (isComingSoon) {
    document.body.classList.add('is-coming-soon');
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chews-blood-flow-driven"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth >= 1280) {
    AOS.init({
      once: true,
      duration: 500,
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chews-vip-upgrade"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.chews-upgrade-section__left');
    const featured = section.querySelector('img');
    const thumbnails = section.querySelectorAll('.chews-upgrade-section__thumbnails img');

    if (!thumbnails.length) return;

    thumbnails[0].classList.add('active');

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.classList.contains('active')) return;

        const newSrc = thumb.src.replace('width=200', 'width=1200');

        featured.classList.add('fade-out');

        setTimeout(() => {
          featured.src = newSrc;
          featured.onload = () => {
            featured.classList.remove('fade-out');
          };
        }, 300);

        thumbnails.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-age"] && !Shopify.designMode) return;
  try {
    
  const btn = document.querySelector('#bottom-box-btn');
  const hiddenMsg = document.querySelector('.home-age-hero__bottom-right-box-bottom');
  const icon = btn.querySelector('span');

  hiddenMsg.style.overflow = 'hidden';
  hiddenMsg.style.maxHeight = '0';
  hiddenMsg.style.opacity = '0';
  hiddenMsg.style.transition = 'max-height 0.4s ease, opacity 0.3s ease';

  btn.addEventListener('click', function () {
    const isOpen = hiddenMsg.style.maxHeight !== '0px';

    if (isOpen) {
      hiddenMsg.style.maxHeight = '0';
      hiddenMsg.style.opacity = '0';
      icon.textContent = '+';
    } else {
      hiddenMsg.style.display = 'flex';
      hiddenMsg.style.maxHeight = (hiddenMsg.scrollHeight + 15) + 'px';
      hiddenMsg.style.opacity = '1';
      icon.textContent = '-';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-meet-vinia"] && !Shopify.designMode) return;
  try {
    
  const dots = document.querySelectorAll('.dot');
  const container = document.querySelector('.home-meet-vinia__right ul');
  const items = container.querySelectorAll('li');

  let isClicking = false;
  let scrollTimeout;

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      isClicking = true;

      dots.forEach((d) => d.classList.remove('active'));
      dot.classList.add('active');

      container.scrollTo({
        left: items[i].offsetLeft,
        behavior: 'smooth',
      });
    });
  });

  container.addEventListener('scroll', () => {
    if (isClicking) {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isClicking = false;
      }, 300);
      return;
    }

    let closestIndex = 0;
    let closestDistance = Infinity;

    items.forEach((item, i) => {
      const distance = Math.abs(container.scrollLeft - item.offsetLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });

    dots.forEach((d) => d.classList.remove('active'));
    if (dots[closestIndex]) dots[closestIndex].classList.add('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-blood-flow-matters"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.hydration-challenge-blood-flow-matters__inner');

  if (!section) return;

  const mq = window.matchMedia('(min-width: 1280px)');

  let active = false;
  let observer;

  const setup = () => {
    observer = new IntersectionObserver(
      ([entry]) => {
        active = entry.isIntersecting;
      },
      { threshold: 0 }
    );

    observer.observe(section);

    window.addEventListener('scroll', onScroll);
  };

  const teardown = () => {
    if (observer) observer.disconnect();
    window.removeEventListener('scroll', onScroll);
    section.style.transform = '';
  };

  const onScroll = () => {
    if (!active) return;

    const start = section.offsetTop;
    const offset = Math.min(Math.max(0, (window.scrollY - start) * 0.25), 40);

    section.style.transform = `translateY(${offset}px)`;
  };

  const handleMQ = (e) => {
    if (e.matches) setup();
    else teardown();
  };

  handleMQ(mq);
  mq.addEventListener('change', handleMQ);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-hero"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.hydration-challenge-hero');

  if (!section) return;

  const mq = window.matchMedia('(min-width: 1280px)');

  const onScroll = () => {
    const offset = window.scrollY * 0.5;
    section.style.backgroundPosition = `100% calc(0% + ${offset}px)`;
  };

  const setup = () => {
    window.addEventListener('scroll', onScroll);
  };

  const teardown = () => {
    window.removeEventListener('scroll', onScroll);
    section.style.backgroundPosition = '';
  };

  const handleMQ = (e) => {
    if (e.matches) setup();
    else teardown();
  };

  handleMQ(mq);
  mq.addEventListener('change', handleMQ);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-join-challenge"] && !Shopify.designMode) return;
  try {
    
  const openers = document.querySelectorAll('.modalOpener');
  const modal = document.getElementById('trackerModal');
  const closer = document.querySelector('.modalCloser');

  openers.forEach((opener) => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  closer.addEventListener('click', () => {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-prize"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth >= 1280) {
    AOS.init({
      once: true,
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-start"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.hydration-challenge_start-part2');
  const img = document.querySelector('.hydration-challenge-start__bottom-bg-img');

  let active = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      active = entry.isIntersecting;
    },
    { threshold: 0 }
  );

  observer.observe(section);

  window.addEventListener('scroll', () => {
    if (!active) return;

    const offset = window.scrollY * 0.05;
    img.style.transform = `translateY(${offset}px)`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-challenge-steps"] && !Shopify.designMode) return;
  try {
    
  const handleAOS = () => {
    if (window.innerWidth >= 1280) {
      AOS.init({ once: true });
    } else {
      document.querySelectorAll('[data-aos]').forEach((el) => {
        el.removeAttribute('data-aos');
        el.removeAttribute('data-aos-delay');
        el.removeAttribute('data-aos-duration');
      });
    }
  };

  handleAOS();
  window.addEventListener('resize', handleAOS);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-take-challenge"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video]').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    const thumbnail = wrapper.querySelector('.video-thumbnail');
    const playBtn = wrapper.closest('.take-challenge__video').querySelector('.take-challenge__video-play-btn');

    if (!video || !playBtn) return;

    playBtn.addEventListener('click', () => {
      if (thumbnail) thumbnail.style.display = 'none';
      playBtn.style.display = 'none';
      video.style.display = 'block';
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-chews-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-countdown]');

    bars.forEach(function (wrap) {
      var endStr = wrap.dataset.countdown;
      var endDate = endStr ? new Date(endStr) : null;
      if (!endDate || isNaN(endDate.getTime())) return;
      var hideDays = wrap.dataset.hideDays === 'true';

      var elDays = wrap.querySelector('[data-countdown-days]');
      var elHours = wrap.querySelector('[data-countdown-hours]');
      var elMins = wrap.querySelector('[data-countdown-minutes]');
      var elExpired = wrap.querySelector('.vip-countdown-bar__expired');
      var elBlocks = wrap.querySelector('.vip-countdown-bar__blocks');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var distance = endDate.getTime() - Date.now();

        if (distance <= 0) {
          if (elBlocks) elBlocks.style.display = 'none';
          if (elExpired) elExpired.style.display = 'block';
          return;
        }

        var days = Math.floor(distance / 86400000);
        var hours = hideDays ? Math.min(24, Math.floor(distance / 3600000)) : Math.floor((distance % 86400000) / 3600000);
        var mins = Math.floor((distance % 3600000) / 60000);

        if (elDays) elDays.textContent = pad(days);
        if (elHours) elHours.textContent = pad(hours);
        if (elMins) elMins.textContent = pad(mins);

        setTimeout(tick, 1000 - (Date.now() % 1000));
      }

      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
